import React from 'react'
import { Link } from 'react-router-dom';
import { Container, Row, Col } from "react-bootstrap";

export default function ShortDescription() {
    return (
        <section className='bg-blue text-white py-5 blue-logo-bg'>
            <Container>
                <Row>

                    {/* Left Text */}
                    <Col md={8}>
                        <h2 className='heading-style-h2 pb-3'>When You’re Ready to Build It Right</h2>
                        <p>
                            We help you move from demanding requirements to clear, durable
                            digital outcomes.
                        </p>
                    </Col>

                    {/* Right Button */}
                    <Col md={4} className="text-md-end mt-3 mt-md-0">
                        <Link to="/contact" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>START THE CONVERSATION</Link>
                    </Col>

                </Row>
            </Container>
        </section>
    )
}
